import "core-js/modules/es.date.to-string.js";
var recentPrograms = [{
  programId: 19158,
  programName: 'College Diploma - Business Administration',
  programLevel: 'Diploma',
  schoolId: 252,
  schoolName: 'Southern Alberta Institute of Technology',
  schoolAddress: 'Calgary, Alberta, Canada',
  intake: new Date('2024-01-01'),
  openDate: new Date('2023-03-29'),
  submissionDeadline: new Date('2023-09-28')
}, {
  programId: 15827,
  programName: 'Associate of Arts - Business',
  programLevel: 'Diploma',
  schoolId: 237,
  schoolName: 'Alexander College - Vancouver',
  schoolAddress: 'Vancouver, British Columbia, Canada',
  intake: new Date('2024-01-01'),
  openDate: new Date('2023-03-22')
}, {
  programId: 255693,
  programName: 'College Diploma - Hospitality - Hotel and Resort Services Management (HMT8G) (Co-op)',
  programLevel: 'Diploma',
  schoolId: 2055,
  schoolName: 'Fanshawe College - Toronto',
  schoolAddress: 'Ontario, Toronto, Canada',
  intake: new Date('2024-01-01'),
  openDate: new Date('2023-03-25'),
  submissionDeadline: new Date('2024-01-01')
}, {
  programId: 681,
  programName: 'College Diploma - Office Administration - Health Services (0986)',
  programLevel: 'Diploma',
  schoolId: 19,
  schoolName: 'St. Lawrence College - Kingston',
  schoolAddress: 'Kingston, Toronto, Canada',
  intake: new Date('2024-01-01'),
  openDate: new Date('2023-03-21')
}, {
  programId: 205257,
  programName: 'Graduate Certificate - Digital Marketing Communications (DMC) (1089)',
  programLevel: 'Post Graduate Certificate',
  schoolId: 19,
  schoolName: 'St. Lawrence College - Kingston',
  schoolAddress: 'Kingston, Toronto, Canada',
  intake: new Date('2024-01-01'),
  openDate: new Date('2023-03-21')
}, {
  programId: 49305,
  programName: 'Graduate Certificate - Business Management (BMT1B)',
  programLevel: 'Post Graduate Certificate',
  schoolId: 1124,
  schoolName: 'Fanshawe College - London South',
  schoolAddress: 'London, Toronto, Canada',
  intake: new Date('2024-01-01'),
  openDate: new Date('2023-03-25'),
  submissionDeadline: new Date('2024-01-01')
}, {
  programId: 30259,
  programName: 'Graduate Certificate - Construction Project Management (CPJ2)',
  programLevel: 'Post Graduate Certificate',
  schoolId: 737,
  schoolName: 'Fanshawe College',
  schoolAddress: 'London, Toronto, Canada',
  intake: new Date('2024-01-01'),
  openDate: new Date('2023-03-25'),
  submissionDeadline: new Date('2024-01-01')
}, {
  programId: 19189,
  programName: 'College Diploma - Software Development (Optional Co-op)',
  programLevel: 'Diploma',
  schoolId: 252,
  schoolName: 'Southern Alberta Institute of Technology',
  schoolAddress: 'Calgary, Alberta, Canada',
  intake: new Date('2024-01-01'),
  openDate: new Date('2023-03-29'),
  submissionDeadline: new Date('2023-09-28')
}, {
  programId: 15825,
  programName: 'Associate of Arts',
  programLevel: 'Diploma',
  schoolId: 237,
  schoolName: 'Alexander College - Vancouver',
  schoolAddress: 'Vancouver, British Columbia, Canada',
  intake: new Date('2024-01-01'),
  openDate: new Date('2023-03-22')
}, {
  programId: 238304,
  programName: 'Associate of Science - Computer Science',
  programLevel: 'Diploma',
  schoolId: 30,
  schoolName: 'Alexander College - Burnaby',
  schoolAddress: 'Burnaby, British Columbia, Canada',
  intake: new Date('2024-01-01'),
  openDate: new Date('2023-03-22')
}];

//to be re-written using useQuery in the future
export var useRecentPrograms = function useRecentPrograms() {
  return {
    programs: recentPrograms
  };
};